import { ConfirmationDialog } from '@components/dialog';
import { Typography } from '@mui/material';

export interface UnconfirmedEmailDialogProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  isLoading?: boolean;
}

export const UnconfirmedEmailDialog = ({
  open,
  onClose,
  onProceed,
  isLoading = false,
}: UnconfirmedEmailDialogProps) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      title={`Insured's Email Address Not Confirmed`}
      isLoading={isLoading}
      dialogPadding='0px'
      sxProps={{
        title: {
          margin: 0,
          padding: 0,
        },
        titleContainerSx: {
          padding: 0,
          margin: 0,
        },
        dialogContent: {
          paddingX: '16px',
        },
        dialogActionsSx: {
          marginBottom: '16px',
        },
      }}
      buttonConfig={{
        alignment: 'right',
        onConfirm: onProceed,
        confirmText: 'Proceed with Bind',
        secondaryText: 'Exit',
        onSecondaryButtonClick: onClose,
        isConfirmButtonDisabled: isLoading,
        isSecondaryButtonDisabled: isLoading,
      }}
    >
      <Typography variant='body2' fontWeight='normal'>
        Insured&apos;s email address has not been confirmed by the Broker. Are you sure you want to proceed with bind?
      </Typography>
    </ConfirmationDialog>
  );
};
